import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  modalContainer: {
    backgroundColor: '#ecf2f1',
    height: "100%",
    padding: "3rem"
  },

  modalDescription: {
    color: '#003e4c',
    fontWeight: "400",
    fontFamily: "'Rubik', sans-serif",
    fontSize: "1.5rem",
    letterSpacing: '1px'
  },
});
export default styles;
